import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MaintenanceState } from './maintenance.reducers';

export const maintenanceState = createFeatureSelector<MaintenanceState>('maintenance');

// Maintenance Context
export const maintenanceContextSelector = createSelector(
    maintenanceState,
    maintenance => maintenance.maintenanceContext
);

// Maintenance Mode
export const maintenanceModeContextSelector = createSelector(
    maintenanceState,
    maintenance => maintenance.maintenanceModeContext
);

// Links
export const maintenanceLinksSelector = createSelector(maintenanceState, maintenance => maintenance.maintenanceLinks);

// Commands
export const maintenanceCommandsSelector = createSelector(
    maintenanceState,
    maintenance => maintenance.maintenanceCommands
);

// Failed Tests
export const maintenanceFailedTestsSelector = createSelector(
    maintenanceState,
    maintenance => maintenance.maintenanceFailedTests
);

// Components
export const maintenanceComponentsSelector = createSelector(
    maintenanceState,
    maintenance => maintenance.maintenanceComponents
);

// Schedule
export const maintenanceScheduleSelector = createSelector(
    maintenanceState,
    maintenance => maintenance.maintenanceSchedule
);

// Tasks Completed
export const maintenanceTasksCompletedSelector = createSelector(
    maintenanceState,
    maintenance => maintenance.maintenanceTasksCompleted
);
